// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import Cookies from 'js-cookie'
import App from './App'
import router from './router'
import store from '@/store';
import BootstrapVue from 'bootstrap-vue'
import axios from '@/axios'
import jquery from 'jquery'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueLazyload from 'vue-lazyload'

import i18n from './lang' // internationalization
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.min.css'
import Pagination from '@/components/Pagination'

// import 'animate.css'


Vue.prototype.$axios = axios
Vue.prototype.$= jquery;

Vue.use(BootstrapVue)
Vue.use(ElementUI)
Vue.use(i18n)
// Vue.use(Element, {
//   size: Cookies.get('size') || 'medium', // set element-ui default size
//   i18n: (key, value) => i18n.t(key, value)
// })

Vue.component('pagination', Pagination);
Vue.use(VueLazyload,{
  preLoad:1.3,
  attempt:1,
  // error:require('./assets/404.png'), //错误图片
  // loading:require('./assets/loading.jpg'),  //加载图片
});

Vue.config.productionTip = false

/** 字符串超长截取省略号显示 */
Vue.filter('ellipsis', function(value, vlength = 12) {
  if (!value) {
    return ''
  }
  if (value.length > vlength) {
    return value.slice(0, vlength) + '...'
  }
  return value
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js